import { CookieOptions } from 'ngx-cookie-service';

export enum Time {
  ONE_HOUR = 1000 * 60 * 60,
  EIGHT_HOURS = 1000 * 60 * 60 * 8,
  HALF_HOUR = 1000 * 60 * 30,
  QUARTER_HOUR = 1000 * 60 * 15,
  ONE_MINUTE = 1000 * 60,
  HALF_MINUTE = 1000 * 30,
  QUARTER_MINUTE = 1000 * 15,
  FIVE_SECONDS = 1000 * 5,
  ONE_DAY = 1000 * 60 * 60 * 24,
  ONE_WEEK = 1000 * 60 * 60 * 24 * 7,
  ONE_MONTH = 1000 * 60 * 60 * 24 * 30,
}

export const COOKIE_OPTIONS: CookieOptions = {
  expires: new Date(new Date().getTime() + Time.EIGHT_HOURS),
  path: '/',
};

export const REGEX_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const DAYS = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
];

export const MONTHS_CALENDAR: string[] = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];
